import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { IsDuplicatePKError } from 'dbweb-core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, tap, concatMap, mergeMap } from 'rxjs/operators';
import { Category } from '../../../services/eleview/types/category';
import { Label } from '../../../services/eleview/types/label';
import { ColumnsWithLetter, NodeTypeEnum, OwnerByEnum } from '../../../services/eleview/types/model';
import { Node } from '../../../services/eleview/types/node';
import { BackFace } from './backface';

export class EditLabel {
	CategoryID: string;
	LabelID: string;
	Name: string;
	Conts?: Node;
	PlainText?: string;

	titleInput = true;
	isAdd = true;
	title?: string;
	readonly?: boolean;
	modify = false;
	constructor(private svr: LabelManagerService, private snackBar: MatSnackBar) {}
	add(categoryID: string) {
		this.isAdd = true;
		this.titleInput = true;
		this.CategoryID = categoryID;
		this.Name = 'æ°çæ ç­¾';
		this.title = this.Name;
		this.Conts = Node.fromInterface({ NodeType: NodeTypeEnum.unknow });
	}
	done() {
		if (!this.title || this.title.length === 0) {
			alert('ä¸è½è¾å¥ç©ºçåç§°');
			return false;
		}
		if (!this.isAdd && this.title !== this.Name) {
			this.modify = true;
		}
		this.Name = this.title;
		this.titleInput = false;
		return true;
	}
	edit() {
		this.title = this.Name;
		this.titleInput = true;
	}
	editCancel() {
		this.titleInput = false;
	}

	private processSave(whereString: string): Observable<boolean> {
		if (this.isAdd) {
			return this.svr.backface
				.addLabel({
					CategoryID: this.CategoryID,
					Name: this.Name,
					Conts: whereString,
					PlainText: this.PlainText
				})
				.pipe(
					map(lbl => {
						const rev = Label.fromInterface(lbl);
						const category = this.svr.categorys.find(v => v.ID === lbl.CategoryID);
						if (!category.Labels) {
							category.Labels = [];
						}
						category.Labels.push(rev);
						return true;
					}),
					catchError((err, caught) => {
						if (err instanceof HttpErrorResponse) {
							const derr = IsDuplicatePKError(err.error);
							if (derr.Yes) {
								this.snackBar.open('åç§°éå¤', 'å³é­', { duration: 5000 });
							} else {
								this.snackBar.open(err.error, 'å³é­', { duration: 5000 });
							}
						} else {
							this.snackBar.open(err, 'å³é­', { duration: 5000 });
						}
						return of(false);
					})
				);
		} else {
			return this.svr.backface
				.updateLabel({
					CategoryID: this.CategoryID,
					ID: this.LabelID,
					Name: this.Name,
					Conts: whereString,
					PlainText: this.PlainText
				})
				.pipe(
					map(lbl => {
						const rev = this.svr.categorys
							.find(v => v.ID === lbl.CategoryID)
							.Labels.find(vv => vv.ID === lbl.ID);
						rev.Name = lbl.Name;
						return true;
					})
				);
		}
	}
	save(): Observable<boolean> {
		// å¦ææ­£å¨ä¿®æ¹åç§°ï¼åèªå¨è¿è¡ç¡®è®¤ï¼å¦æç¡®è®¤å¤±è´¥ï¼åéåºå¤ç
		if (this.titleInput) {
			if (!this.done()) {
				return of(false);
			}
		}
		const rev = new Subject<boolean>();

		// è½¬æ¢node-->string
		if (this.Conts && this.Conts.NodeType !== NodeTypeEnum.unknow) {
			this.svr.backface.nodeToString(this.Conts.toInterface()).subscribe(whereString => {
				this.processSave(whereString).subscribe(v => {
					rev.next(v);
				});
			});
		} else {
			return this.processSave('');
		}
		return rev;
	}
}
@Injectable()
export class LabelManagerService {
	// åå§åæ¶è®¾ç½®
	eleName: string;
	ownerBy: OwnerByEnum;
	owner: string;
	// ææçæ ç­¾æ°æ®
	categorys: Category[];
	editLabel = new EditLabel(this, this.snackBar);
	allColumnsWithLetter: ColumnsWithLetter;
	backface: BackFace;
	constructor(private snackBar: MatSnackBar) {}
	removeLabel(CategoryID: string, LabelID: string) {
		return this.backface.removeLabel({ CategoryID: CategoryID, ID: LabelID }).pipe(
			tap(v => {
				if (v) {
					const labels = this.categorys.find(vv => vv.ID === CategoryID).Labels;
					labels.splice(labels.findIndex(vv => vv.ID === LabelID), 1);
				}
			})
		);
	}
	removeCategory(id: string) {
		return this.backface.removeCategory(id).pipe(
			tap(v => {
				if (v) {
					this.categorys.splice(this.categorys.findIndex(vv => vv.ID === id), 1);
					this.categorys.forEach((vv, idx) => (vv.Position = idx + 1));
				}
			})
		);
	}
	addCategory(param: { name: string; beforeAtID?: string }) {
		return this.backface
			.addCategory({
				EleName: this.eleName,
				Name: param.name,
				OwnerBy: this.ownerBy,
				BeforeAtID: param.beforeAtID
			})
			.pipe(
				tap(v => {
					// è°æ´ä½ç½®å¹¶æå¥
					if (param.beforeAtID) {
						const idx = this.categorys.findIndex(vv => vv.ID === param.beforeAtID);
						this.categorys.splice(idx, 0, v);
					} else {
						this.categorys.push(v);
					}
					this.categorys.forEach((vv, idx) => (vv.Position = idx + 1));
				})
			);
	}
	editCategory(param: { id: string; name: string }) {
		return this.backface
			.updateCategory({
				ID: param.id,
				Name: param.name,
				OwnerBy: this.ownerBy
			})
			.pipe(
				tap(v => {
					this.categorys.find(vv => vv.ID === param.id).Name = param.name;
				})
			);
	}
	fetchCategoryLabelHis() {
		return this.backface.fetchCategoryLabelHis({
			EleName: this.eleName,
			OwnerBy: this.ownerBy,
			Owner: [this.owner]
		});
	}
	fetchCategories() {
		this.backface
			.fetchCategories({ EleName: this.eleName, OwnerBy: this.ownerBy, Owner: this.owner })
			.subscribe(v => {
				this.categorys = v;
			});
	}
	setCategoryPosition(cate: Category, idx: number) {
		this.backface.setCategoryPosition({ ID: cate.ID, Position: idx }).subscribe(v => {
			// åèµå¼position
			v.forEach(vv => {
				const findc = this.categorys.find(c => c.ID === vv.ID);
				if (findc) {
					findc.Position = vv.Position;
				}
			});
			// åæåº
			this.categorys.sort((a, b) => a.Position - b.Position);
		});
	}
}
